import { jwtDecode } from 'jwt-decode'

type ConnectClaims = {
  kind?: string
  aud?: string | string[]
  subs?: Record<string, unknown>
  channels?: string[]
}

function audienceList(aud: string | string[] | undefined): string[] {
  if (Array.isArray(aud)) return aud.map(String)
  if (aud != null) return [String(aud)]
  return []
}

function isConnectTicketPass(claims: ConnectClaims): boolean {
  const kind = String(claims.kind ?? '').toLowerCase()
  if (kind.includes('connect')) return true
  return audienceList(claims.aud).some((a) => a.includes('realtime-connect'))
}

/**
 * Validate which channels a *Centrifugo connection JWT* grants as server-side `subs`.
 * Connect-ticket passes (`kind: operator-connect-v1`) have no `subs` — channels
 * come from the connect proxy. Do not treat that as a backend bug.
 */
export function logCentrifugeConnectionSubs(
  token: string,
  expectedNotificationsChannel?: string,
): string[] {
  try {
    const claims = jwtDecode<ConnectClaims>(token)
    if (isConnectTicketPass(claims)) {
      return []
    }
    const subs = Object.keys(claims.subs ?? {})
    if (expectedNotificationsChannel && !subs.includes(expectedNotificationsChannel)) {
      console.error(
        '[transfer] BACKEND: connection token does not embed',
        expectedNotificationsChannel,
        'in JWT `subs`. Client subscribe also gets 103 permission denied — ' +
          'POST /api/token must add this channel to `subs` (or allow client subscribe).',
      )
    }
    return subs
  } catch (err) {
    console.warn('[transfer] failed to decode connection JWT', err)
    return []
  }
}
